export { default } from "./sidebarSearchPanel";
